(() => {
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 1000px)');
  function init(root = document) {
    root.querySelectorAll('[data-nollis-hero], [data-nollis-story]').forEach(el => {
      if (instances.has(el)) return;
      let frame = 0;
      const chapters = [...el.querySelectorAll('[data-story-chapter]')];
      const photos = [...el.querySelectorAll('[data-story-frame]')];
      let active = '';
      const update = () => {
        frame = 0;
        if (!el.isConnected) return;
        if (el.hasAttribute('data-nollis-hero')) {
          const rect = el.getBoundingClientRect();
          const value = el.dataset.motion === 'true' && !reduced.matches ? Math.max(0, Math.min(1, -rect.top / rect.height)) : 0;
          el.style.setProperty('--nollis-scroll', value.toFixed(3));
        }
        if (chapters.length && desktop.matches) {
          let chosen = chapters[0];
          let distance = Infinity;
          const target = innerHeight * .46;
          chapters.forEach(chapter => {
            const rect = chapter.getBoundingClientRect();
            const d = Math.abs(rect.top + rect.height * .5 - target);
            if (d < distance) { chosen = chapter; distance = d; }
          });
          activate(chosen);
        }
      };
      const activate = chapter => {
        if (active === chapter.dataset.storyChapter) return;
        active = chapter.dataset.storyChapter;
        photos.forEach(photo => photo.classList.toggle('is-active', photo.dataset.storyFrame === active));
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const section = el.closest('.shopify-section');
      const select = event => {
        if (!section || !section.contains(event.target)) return;
        const chapter = chapters.find(c => c === event.target || c.contains(event.target));
        if (chapter) {
          activate(chapter);
          if (!desktop.matches) chapter.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'start' });
        }
      };
      if (el.dataset.motion === 'false' || reduced.matches) el.style.setProperty('--nollis-transition', '0s');
      addEventListener('scroll', schedule, { passive: true });
      addEventListener('resize', schedule, { passive: true });
      document.addEventListener('shopify:block:select', select);
      reduced.addEventListener('change', schedule);
      instances.set(el, () => {
        removeEventListener('scroll', schedule);
        removeEventListener('resize', schedule);
        document.removeEventListener('shopify:block:select', select);
        reduced.removeEventListener('change', schedule);
        cancelAnimationFrame(frame);
      });
      update();
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, el) => {
      if (event.target.contains(el)) { dispose(); instances.delete(el); }
    });
  });
})();
